/**
 * Format a number for display as years.
 * Round to a whole number and add ' years' to the end.
 * If null, return null.
 * @param value - A number representing a number of years.
 * @returns A stringified value in this format: 10 years
 */
export function formatAsYears(value?: number | null) {
  if (value == null) {
    return null
  }
  const integer = Math.round(value)
  return `${integer} year${integer > 1 ? 's' : ''}`
}
